import { useContext } from 'react';

import { media } from 'context';
import { Img, Layout, PillButton, Text } from 'ds';

import { ReactComponent as CirclesDesktop } from './circles-desktop.svg';
import { ReactComponent as CirclesMobile } from './circles-mobile.svg';

const OfficeWillRunItself = () => {
  const { isMobile, sm } = useContext(media);

  return (
    <Layout flex direction="column" gap={isMobile ? 36 : undefined}>
      <Layout flex direction="column" gap={36}>
        <Text size={isMobile ? 'headline-xs' : 'headline-md'}>Your next office will run itself</Text>
        <Layout flex direction="row" gap={24} align={isMobile ? 'flex-end' : undefined}>
          <Layout direction="column" gap={12}>
            <Text size="body-md" semibold>
              (Human) support when you need it most
            </Text>
            <Text size="body-sm" color="gray-700">
              Our office support team is available from Monday–Friday, 9AM–5PM. We’re committed to helping you every
              step of the way.
            </Text>
          </Layout>
          <Img
            srcKey={'Justin-zoomed-in_IAd6wmYyW.png'}
            style={{
              width: 96,
              height: 96,
              borderRadius: '50%'
            }}
            alt={'Justin'}
            width={200}
            folder="ux"
          />
        </Layout>
      </Layout>
      <Layout
        flex
        direction={sm || isMobile ? 'column' : 'row'}
        height={sm || isMobile ? undefined : 300}
        align={sm || isMobile ? undefined : 'center'}
      >
        <Layout direction="column" gap={12} width={300}>
          <Text size="body-md" semibold>
            Meet your AI office assistant
          </Text>
          <Text size="body-sm" color="gray-700">
            Stop wasting time on office logistics. Codi automates it all.
          </Text>
          <Layout flex>
            <PillButton
              type="purpleGradient"
              size="sm"
              text={'Learn more'}
              fullWidth={false}
              borderRadius={16}
              href={'/ai-office-assistant'}
            />
          </Layout>
        </Layout>
        <Layout
          flex
          position="relative"
          marginTop={isMobile ? 30 : undefined}
          justify={isMobile ? 'center' : undefined}
        >
          <Layout
            {...(!sm && !isMobile && { position: 'absolute', top: -140, left: 50 })}
            width={311}
            height={323}
            zIndex={1}
          >
            <Img
              srcKey="Frame%201000004135_yItm92aKe.png?updatedAt=1744062501507"
              folder="ux"
              width={889}
              height={800}
              alt="Codi"
            />
          </Layout>
          {!isMobile && (
            <CirclesDesktop
              width={409}
              height={167}
              style={{ position: 'absolute', top: sm || isMobile ? 130 : -10, left: isMobile ? -20 : 0, zIndex: 0 }}
            />
          )}
          {isMobile && (
            <CirclesMobile width={358} height={246} style={{ position: 'absolute', top: 150, left: 0, zIndex: 0 }} />
          )}
        </Layout>
      </Layout>
    </Layout>
  );
};

export default OfficeWillRunItself;
